import(/* webpackMode: "eager", webpackExports: ["Hero"] */ "/home/runner/work/dex-frontend/dex-frontend/apps/web/src/app/(networks)/(evm)/claim/hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationItems"] */ "/home/runner/work/dex-frontend/dex-frontend/apps/web/src/app/(networks)/(evm)/claim/navigation-items.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/home/runner/work/dex-frontend/dex-frontend/apps/web/src/app/(networks)/(evm)/header.tsx");
